import { createSlice } from '@reduxjs/toolkit';
import api from 'api';
import formErrorsHandle from '../../../utils/formErrorsHandle';
import toast from 'react-hot-toast';

const initialState = {
  loading: false,
  emailNotificationList: []
};
const emailNotification = createSlice({
  name: 'emailNotification',
  initialState,
  reducers: {
    setLoading(state, action) {
      return {
        ...state,
        loading: action.payload
      };
    },
    getList(state, action) {
      return {
        ...state,
        emailNotificationList: action.payload?.data?.result,
        count: action.payload?.data?.count
      };
    }
  }
});

export const emailNotificationActions = emailNotification.actions;

export const getEmailNotificationAction = (data) => async (dispatch) => {
  dispatch(emailNotificationActions.setLoading(true));
  try {
    const res = await api.post(`api/BillingNotification/Filter`, data);
    if (res.status === 200 && res?.data) {
      dispatch(emailNotificationActions.getList(res.data));
      return Promise.resolve(res?.data);
    }
  } catch (errors) {
    formErrorsHandle(errors.response?.data, []);
    return Promise.reject(errors.response?.data);
  } finally {
    dispatch(emailNotificationActions.setLoading(false));
  }
};

export const addEmailNotificationAction = (data) => async () => {
  try {
    const res = await api.post(`api/BillingNotification/Create`, data);
    if (res.status === 200) {
      return Promise.resolve(res?.data);
    }
  } catch (errors) {
    return Promise.reject(errors.response?.data);
  }
};

export const removeEmailNotificationAction = (id) => async () => {
  try {
    const res = await api.delete(`api/BillingNotification/Delete/${id}`);
    if (res.status === 200 && res?.data) {
      toast.success('Removed successfully!!!');
      return Promise.resolve(res?.data);
    }
  } catch (errors) {
    formErrorsHandle(errors.response?.data, []);
    return Promise.reject(errors.response?.data);
  }
};
export default emailNotification.reducer;
